import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { VehicleManageService } from '../shared/services/vihicle-manage.service';
import { MatSort, MatTableDataSource } from '@angular/material';

@Component( {
  selector: 'app-operator-vehicles',
  templateUrl: './operator-vehicles.component.html',
  styleUrls: ['./operator-vehicles.component.scss']
} )
export class OperatorVehiclesComponent implements OnInit, AfterViewInit {

  title = 'LOGIST_CONFIG_TITLE';
  vehicles: any[];
  allVehicles: any[];
  service_id;
  dataSource = new MatTableDataSource();
  displayedColumns = ['id', 'number', 'info', 'color', 'remove'];
  @ViewChild( MatSort ) sort: MatSort;

  constructor ( private vehicleManageService: VehicleManageService ) {}

  ngOnInit () {
    this.getCarForLogist();
    this.getAllVehicles();
    this.vehicleManageService.LogistGetAllCabs( this.service_id ).subscribe( data => {
      console.log( data );
    } );
  }

  ngAfterViewInit () {
    this.dataSource.sort = this.sort;
  }

  getAllVehicles () {
    this.vehicleManageService.getAllBudjetVehicle( this.service_id )
      .subscribe(
        vehicles => {
          console.log( 'getAllVehicle!' );
          console.log( vehicles );
          this.allVehicles = vehicles;
        }
      );
  }

  removeCar ( code ) {

    this.vehicleManageService.LogistRemoveCar( this.service_id, code )
      .subscribe(
        data => {
          console.log( data );
          // this.getCarForLogist();
        }
      );
  }

  addCar ( code ) {
    this.vehicleManageService.LogistAddCar( this.service_id, code )
      .subscribe(
        data => {
          console.log( data );
          console.log( 'add!' );
          this.getCarForLogist();
        }
      );
  }

  getCarForLogist () {
    this.vehicleManageService.LogistGetVehicles( this.service_id )
      .subscribe(
        vehicles => {
          this.dataSource = vehicles;
          console.log( this.dataSource );
          this.vehicles = vehicles;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/operator-vehicles/operator-vehicles.component.ts